import PropTypes from "prop-types";
import FacetValues from "../FacetValues";
import classnames from "classnames";
import ClearButton from "../../ToggleButton/ClearButton";
import SelectAllButton from "../../ToggleButton/SelectAllButton";
import { getFacetValuesToDisplay } from "../../../helpers/getFacetValuesToDisplay";
import withTextFilter from "../../../containers/withTextFilter";
import { withTranslation } from "../../translation";
import { NoFilterSearchBoxMatches } from "../../NoFilterSearchBoxMatches";
import hasAnySelectedValue from "../helpers/hasAnySelectedValue";
import { RefinementListCloseButton } from "../CloseButton";

const SecondaryList = props => {
  const {
    styles,
    facet,
    formatTranslation,
    isFiltered,
    searchBox,
    filteredFacetValues,
    clearSearchBox
  } = props;

  if (facet === undefined) return null;

  const facetValuesToDisplay = getFacetValuesToDisplay({
    isFiltered,
    filteredFacetValues,
    facet
  });

  const facetToDisplay = {
    ...facet,
    facetValues: facetValuesToDisplay
  };

  const hasSelectedFacet = hasAnySelectedValue([props.facet]);

  const handleBackClick = () => {
    clearSearchBox && clearSearchBox();
    props.back(props.facet);
  };

  const handleViewItemsClick = () => {
    props.viewList(props.facet);
  };

  return (
    <div className={styles.secondaryList}>
      <div className={styles.listWrapper}>
        <header className={styles.refinementsHeader}>
          <div className={styles.topLine}>
            <button
              className={styles.backArrow}
              onClick={handleBackClick}
              aria-label={formatTranslation("accessibility_label_back")}
            ></button>
            <h3 className={classnames(styles.refinementsTitle)}>
              {facet.name}
            </h3>
            <RefinementListCloseButton
              onClick={handleViewItemsClick}
              formatTranslation={formatTranslation}
            />
          </div>
          {searchBox}
          <div className={styles.srOnly} aria-live="assertive">
            {facetValuesToDisplay.length === 0
              ? "no results available"
              : `${facetValuesToDisplay.length} result${
                  facetValuesToDisplay.length > 1 ? "s" : ""
                } available`}
          </div>
        </header>
        <div
          className={classnames(styles.refinementsListWrapper, {
            [styles.filterableRefinementsListWrapper]: searchBox,
            [styles.unfilterableRefinementsListWrapper]: !searchBox
          })}
        >
          <div
            className={classnames(styles.refinementsList, {
              [styles.noPadding]: facet.id === "brand"
            })}
          >
            <FacetValues
              facet={facetToDisplay}
              changeMultiFacet={props.changeMultiFacet}
            />
            <NoFilterSearchBoxMatches
              isFiltered={isFiltered}
              filteredFacetValues={filteredFacetValues}
              formatTranslation={formatTranslation}
            />
          </div>
        </div>
      </div>
      <footer className={styles.footer}>
        {hasSelectedFacet ? (
          <ClearButton
            className={styles.clearBtn}
            onClick={() => props.clear(facet.id)}
            disabled={false}
          >
            {formatTranslation("plp_web_refinements_list_clear")}
          </ClearButton>
        ) : (
          <SelectAllButton
            className={styles.selectAllBtn}
            iconClassName=""
            openFacet={props.facet}
            onClick={() => props.selectAll(facet.id)}
            disabled={hasSelectedFacet || isFiltered}
          >
            {formatTranslation("plp_web_refinements_list_all")}
          </SelectAllButton>
        )}

        <button className={styles.viewItemsBtn} onClick={handleViewItemsClick}>
          {formatTranslation("plp_web_refinements_list_view_items", {
            smart_count: props.itemCount
          })}
        </button>
      </footer>
    </div>
  );
};

SecondaryList.propTypes = {
  facet: PropTypes.object,
  itemCount: PropTypes.number,
  styles: PropTypes.object.isRequired,
  clear: PropTypes.func.isRequired,
  selectAll: PropTypes.func.isRequired,
  viewList: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
  changeMultiFacet: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  isFiltered: PropTypes.bool,
  searchBox: PropTypes.object,
  filteredFacetValues: PropTypes.array,
  clearSearchBox: PropTypes.func
};

export default withTextFilter(withTranslation(SecondaryList));
